import { ReactNode } from 'react'
import { useTranslation } from 'react-i18next'
import { OrderDetails } from '~/shared/api/services/delivery/types'

interface OrderDetailsHeaderProps {
  orderDetails?: OrderDetails
  shippingMethod?: string
  titlePrefixSlot?: ReactNode
}

export const OrderDetailsHeader = ({
  orderDetails,
  shippingMethod,
  titlePrefixSlot,
}: OrderDetailsHeaderProps) => {
  const { t } = useTranslation(['common', 'delivery'])

  return (
    <div className="flex flex-col gap-3 pb-4 ">
      <div className="flex items-center gap-4">
        {titlePrefixSlot}
        <div className="text-[24px] text-[#242424]">
          <p>
            {t('delivery:boxOrderCheck', {
              box: orderDetails?.box,
              number: orderDetails?.number,
              label: orderDetails?.label ?? '',
            })}
          </p>
        </div>
      </div>
      <p className="text-[14px] text-[#707070]">
        {t('delivery:weightInfo', {
          weight: orderDetails?.weight,
          weightVolume: orderDetails?.weightVolume,
          shippingMethod,
        })}
      </p>
      <p className="text-[14px] text-[#707070]">
        {t('delivery:userAssembledOrder', {
          userName: orderDetails?.userName,
        })}
      </p>
    </div>
  )
}
